import * as React from "react";

import { cn } from "@/libs/utils";
import { VariantProps, cva } from "class-variance-authority";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const inputVariants = cva(
  [
    "peer",
    "text-base flex py-[14px] px-4 w-full rounded border -outline-offset-2 truncate",
    "border-coolgray-20 bg-transparent",
    "file:border-0 file:text-lg file:bg-transparent",
    "placeholder:text-coolgray-40",
    "focus:outline focus:outline-2 focus:outline-blue-60",
    "disabled:cursor-not-allowed disabled:text-coolgray-30",
    "read-only:focus:outline-0",
    // error styles in <Form />
    "aria-[invalid=true]:outline  aria-[invalid=true]:outline-2 aria-[invalid=true]:outline-red-60",
  ],
  {
    variants: {
      error: {
        true: "outline outline-2 !outline-red-60",
      },
    },
  },
);

const Input = React.forwardRef<
  HTMLInputElement,
  InputProps & VariantProps<typeof inputVariants>
>(({ className, error, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(inputVariants({ error }), className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
